import { ButtonNavigateToCars } from 'src/features/ButtonNavigateToCars'
import { TooltipWrapper } from 'src/components/Tooltip'

import { useMakePdfInfoCar } from 'src/features/MakePdfInfoCar/useMakePdfInfoCar'
import { Button } from 'src/components/shadcn/button'

export const MakePdfInfoCar = (): JSX.Element => {
  const { handleDownloadPDF, locale } = useMakePdfInfoCar()

  return (
    <div className="flex flex-col mt-8">
      <div className="flex items-center space-x-7">
        <span className="text-lg font-medium">{locale.infoCar}</span>
        <div>
          <TooltipWrapper text={locale.tooltipPDF}>
            <Button
              className="rounded-[10px]"
              variant="secondary"
              onClick={handleDownloadPDF}
            >
              {locale.downloadBtn}
            </Button>
          </TooltipWrapper>
          <ButtonNavigateToCars />
        </div>
      </div>
    </div>
  )
}
